<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
    <span class="cf-icon cf-icon--large cf-icon--red far fa-exclamation-circle" />

    <h1 class="cf-title cf-title--1">
      Your cart is currently empty.
    </h1>

    <p class="cf-subtitle cf-subtitle--2">
      Browse our menu to start adding items to your cart.
    </p>

    <button
      class="cf-button cf-button--primary cf-button--lg"
      type="button"
      @click="browseMenuHandler"
    >
      Browse Menu
    </button>

    <button
      v-if="isGroupOrderButtonEnabled"
      class="cf-button cf-button--secondary cf-button--lg"
      title="Start a group order"
      type="button"
      @click="startGroupOrderClickHandler"
    >
      <span class="cf-icon far fa-users" />
      Start a Group Order
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'EmptyCart',

    computed: {
      ...mapGetters('orders', ['order', 'showGroupOrderButton']),

      isGroupOrderButtonEnabled() {
        return this.showGroupOrderButton && !this.order.groupOrder.token;
      }
    },

    methods: {
      browseMenuHandler() {
        this.$closeModal('empty-cart-modal');

        this.$router.push({ name: 'orderMenu', params: { merchantId: this.$route.params.merchantId } });
      },

      startGroupOrderClickHandler() {
        this.$closeModal('empty-cart-modal');

        this.$openModal('editGroupOrder');
      }
    }
  };
</script>
